import * as React from 'react';
import Espot from 'src/assets/images/avnet-espot-farnell.png';

const ProductDetailAd = (props) => {
    return (
        <>
            <div id='espot-ads-section'>
                <div className="mb-3 ad-block" id='espotAdsOne'>
                    <a href='https://export.farnell.com/?CMP=EMEA-AVNET-ESPOT' target='_blank' title='Click here to open Farnell Store'><img className='mw-100' src={Espot} /></a>
                </div>
                <div className="mb-3" id='pdpEspotThree'>
                    
                </div>
            </div>
        </>
    );
}

export default ProductDetailAd;